import React from 'react';
import { headingFontBold, vars } from '../../../../../Theme';
import { Box, SxProps } from '@mui/material';

const titleSx: SxProps = {
    pr: 0.5,
    mb: 1,
    ...headingFontBold,
    color: vars.black,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 'normal',
};

export default ({ title }: { title: string }) => {
    return <Box sx={titleSx}>{title}</Box>;
};
